"use client";

import React from "react";
import { Mail } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface ExtrusionQuoteCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, ExtrusionQuoteCopy> = {
  en: {
    eyebrow: "Polymer & Extrusion Filtration",
    heading: "Request a Custom Extruder Mesh Quotation",
    lead: "Share your mesh count, wire diameter, alloy grade, and filter pack dimensions for technical review and volume pricing.",
    primaryLabel: "Request a Quote",
    secondaryLabel: "Contact Engineering"
  },
  zh: {
    eyebrow: "聚合物与熔体挤出过滤",
    heading: "索取定制挤出过滤网组技术报价",
    lead: "请提供目数规格、丝径、合金牌号及滤片组合尺寸。我们的工程团队将为您的挤出工况核算公差与批量报价。",
    primaryLabel: "索取报价",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Filtración de polímeros y extrusión",
    heading: "Solicite una cotización de mallas para extrusión",
    lead: "Comparta la abertura de malla, diámetro de alambre, aleación y dimensiones de discos o filtros para evaluación técnica y precios.",
    primaryLabel: "Solicitar presupuesto",
    secondaryLabel: "Contactar ingeniería"
  },
  de: {
    eyebrow: "Polymer- & Extrusionsfiltration",
    heading: "Angebot für Extrusionssiebe und Filterpakete anfordern",
    lead: "Geben Sie Maschenzahl, Drahtdurchmesser, Legierung und Abmessungen der Siebpakete für eine technische Prüfung und Preiskalkulation an.",
    primaryLabel: "Angebot anfragen",
    secondaryLabel: "Engineering kontaktieren"
  },
  fr: {
    eyebrow: "Filtration d'extrusion et de polymères",
    heading: "Demander un devis pour toiles de filtration d'extrusion",
    lead: "Partagez votre nombre de mailles, diamètre de fil, nuance d'alliage et dimensions de packs filtrants pour évaluation technique et chiffrage.",
    primaryLabel: "Demander un devis",
    secondaryLabel: "Contacter l'ingénierie"
  },
  pt: {
    eyebrow: "Filtração de polímeros e extrusão",
    heading: "Solicitar cotação de telas para extrusão",
    lead: "Compartilhe a contagem de malha, diâmetro do fio, liga e dimensões dos pacotes filtrantes para revisão técnica e cotação.",
    primaryLabel: "Solicitar orçamento",
    secondaryLabel: "Falar com engenharia"
  }
};
export default function Quote() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: content.primaryLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} />;
}